export interface IkindRewardFilterData {
	tournamentID: number;
	userId: number;
}

export interface IListUserKindRewardPayload {
	uid: number;
	ltid: number;
	rank: number;
	winningAmount: number;
	kindReward: string;
	playingAttempt: number;
	winningTime: number;
	registrationId: string;
}

export interface RESPONSE<T> {
	success: boolean;
	externalMessage?: string;
	message?: string;
	data?: T;
}

export enum EWinningCreditType {
	CASH = 'CASH',
	KIND = 'KIND'
}

export interface IKindRewardCreditPayload {
	registrationId?: string;
	creditType: EWinningCreditType;
	buyingPrice: number;
	isTDSEligible?: boolean;
}

export interface IMakeActionList {
	bulkActions: never[];
	rowActions: {
		name: string;
		id: string;
		isEnabled: () => boolean;
	}[];
}

export type ContentPropsT = {
	onClose: () => void;
	handleRewardCredit: (submittedData: IKindRewardCreditPayload, rowData: any) => void;
	handleFilterSubmit: (submittedFilters: IkindRewardFilterData) => void;
	rowData?: IListUserKindRewardPayload;
};
